export enum ReviewResult {
    APPROVED = 'Approved',
    DECLINED = 'Declined',
    REASSIGNED = 'Reassigned'
}
